import React from 'react';
import PropTypes from 'prop-types';
import { SaveMyCarsButton } from 'wsm-mycars-ctas';
import { useGalleryContext } from '../../contexts/GalleryContext';

/**
 * MyCarsSaveIcon component - wraps the MyCarsCtas component with vehicle data
 * Only displays the Save button (not Track Price)
 */
const MyCarsSaveIcon = ({ className = '' }) => {
	const { meta } = useGalleryContext();
	const { vehicle = {}, pathParameters, accountId } = meta || {};

	const {
		make = '',
		year = '',
		model = '',
		trim = '',
		bodyStyle = '',
		type = '',
		vin = '',
		stockNumber = ''
	} = vehicle;

	const uuid = pathParameters?.vehicleId;
	// In case, siteId is accountId (read line 108 from store.js)
	const siteId = accountId;

	// Create title array by filtering out empty values and converting to strings
	const titleArray = [year, make, model, trim]
		.filter(Boolean)
		.map((value) => String(value));

	if (!uuid) {
		return null;
	}

	return (
		<div className={className} data-testid="mycars-save-icon">
			<SaveMyCarsButton
				uuid={uuid}
				accountId={vehicle.accountId}
				siteId={siteId}
				bodyStyle={bodyStyle}
				make={make}
				model={model}
				title={titleArray}
				trim={trim}
				type={type}
				vin={vin}
				year={year}
				stockNumber={stockNumber || ''}
			/>
		</div>
	);
};

MyCarsSaveIcon.propTypes = {
	className: PropTypes.string
};

export default MyCarsSaveIcon;
